import { render, staticRenderFns } from "./product-item-option.vue?vue&type=template&id=65a86acc&scoped=true&"
import script from "./product-item-option.vue?vue&type=script&lang=js&"
export * from "./product-item-option.vue?vue&type=script&lang=js&"
import style0 from "./product-item-option.vue?vue&type=style&index=0&id=65a86acc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a86acc",
  null
  
)

export default component.exports